import cn from 'classnames';

import BillingButtons from 'components/checkout/caap/address/addresslist/BillingButtons';
import ShippingButtons from 'components/checkout/caap/address/addresslist/ShippingButtons';
import styles from 'styles/components/checkout/caap/address/addressListButtons.scss';

const AddressListButtons = componentParams => {
  const {
    addressId,
    isBilling,
    isFetchingCheckoutData,
    onDeleteAddressClick,
    onEditAddressClick,
    onUseThisAddressClick,
    selectedAddressId
  } = componentParams;

  const itemStyles = cn(
    {
      [styles.content]: true,
      [styles.notSelected]: selectedAddressId !== addressId
    }
  );

  return (
    <div className={itemStyles}>
      {
        isBilling
          ? <BillingButtons
            addressId={addressId}
            isFetchingCheckoutData={isFetchingCheckoutData}
            onUseThisAddressClick={onUseThisAddressClick}
          />
          : <ShippingButtons
            addressId={addressId}
            isFetchingCheckoutData={isFetchingCheckoutData}
            onDeleteAddressClick={onDeleteAddressClick}
            onEditAddressClick={onEditAddressClick}
            onUseThisAddressClick={onUseThisAddressClick}
          />
      }
    </div>
  );
};

export default AddressListButtons;
